document.documentElement.classList.remove('no-js');

const onReady = (callback) => {
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', callback, { once: true });
  } else {
    callback();
  }
};

onReady(() => {
  const menuButton = document.querySelector('[data-menu-toggle]');
  const menuClose = document.querySelector('[data-menu-close]');
  const menu = document.querySelector('[data-mobile-menu]');

  if (menuButton && menu) {
    const setMenu = (open) => {
      menuButton.setAttribute('aria-expanded', String(open));
      menu.hidden = !open;
      document.body.classList.toggle('menu-open', open);
    };

    menuButton.addEventListener('click', () => setMenu(menu.hidden));
    menuClose?.addEventListener('click', () => setMenu(false));
  }

  document.querySelectorAll('[data-quantity-change]').forEach((button) => {
    button.addEventListener('click', () => {
      const input = button.parentElement.querySelector('input[type="number"]');
      if (!input) return;
      const delta = Number(button.dataset.quantityChange);
      const minimum = Number(input.min || 1);
      input.value = Math.max(minimum, Number(input.value || minimum) + delta);
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });
  });
});
